import { useState } from "react";

export function MenuShowCase({ data }) {
  const [activeMenu, setActiveMenu] = useState(0);
  return (
    <section className="menushowcase lg:d-block md:d-none mx-auto bg-light-blue-grey lg:pb-20 ">
      <h2 className="text-lg container lg:mb-10 ">{data.heading}</h2>
      <div className="container menu-fx fx ">
        <ul className="menus">
          {data.items &&
            data.items.map((item, index) => (
              <li key={item.id}>
                <button
                  className={`fx fx--sb menu mb-1 ${
                    activeMenu === item.id ? "active" : ""
                  }`}
                  aria-expanded={activeMenu === index}
                  data-id={item.id}
                  onClick={() => setActiveMenu(item.id)}
                >
                  {item.title}
                  <span
                    className="ml-auto"
                    dangerouslySetInnerHTML={{ __html: item.icon }}
                  />
                </button>
              </li>
            ))}
        </ul>
        <div className="container-box ">
          {data.items.map((item, index) => (
            <div
              key={item.id}
              className={`share-options-content fx ${
                activeMenu === item.id ? "showoption" : ""
              }`}
              aria-hidden={activeMenu !== index}
              data-content={item.id}
            >
              <h2 className="mb-3">{item.heading}</h2>
              {Array.isArray(item.desc) ? (
                item.desc.map((desc, index) => (
                  <p
                    className="mb-3 "
                    dangerouslySetInnerHTML={{ __html: desc }}
                    key={index}
                  />
                ))
              ) : (
                <p
                  className="mb-3 "
                  dangerouslySetInnerHTML={{ __html: item.desc }}
                />
              )}
              {item.note && (
                <p
                  className="mb-3"
                  dangerouslySetInnerHTML={{ __html: item.note }}
                />
              )}
              {item.list && (
                <ul className="lg:px-4 mb-3 ">
                  {item.list.map((list, index) => (
                    <li
                      className="mb-1 show-case-list-item"
                      dangerouslySetInnerHTML={{ __html: list }}
                      key={index}
                    />
                  ))}
                </ul>
              )}
              <div className="bg-light-blue-grey img-container ">
                <img src={`${item.src}`} alt="Booking Preview" width="100%" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
